module.exports = __webpack_public_path__ + "static/media/preview1.a60e791f.jpg";